"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptimizationEvents = void 0;
var OptimizationEvents;
(function (OptimizationEvents) {
    OptimizationEvents["IN_PROGRESS"] = "optimization progress";
    OptimizationEvents["DONE"] = "optimization done";
})(OptimizationEvents = exports.OptimizationEvents || (exports.OptimizationEvents = {}));
//# sourceMappingURL=RouteOptimization.consts.js.map